/* import __COLOCATED_TEMPLATE__ from './project-prices.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class ProjectPricesModalComponent extends Component {
  @service router;

  get projects() {
    return this.model.loadProjectsTaskInstance.value ?? [];
  }

  @action
  handleViewProject(applicationId) {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS, applicationId);
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default ProjectPricesModalComponent;
